export default __webpack_public_path__ + "static/media/cz-shadow-2.317b787d.svg";